document.addEventListener('DOMContentLoaded', function(){
  var drawer = document.getElementById('CartDrawer');
  function openDrawer(){ if(drawer){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); } }
  function closeDrawer(){ if(drawer){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); } }
  document.querySelectorAll('[data-cart-close]').forEach(function(el){ el.addEventListener('click', closeDrawer); });
  document.querySelectorAll('[data-cart-open]').forEach(function(el){ el.addEventListener('click', function(e){ e.preventDefault(); openDrawer(); }); });

  function updateCartCount(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var bubble = document.getElementById('CartCount');
      if(bubble){ bubble.textContent = cart.item_count; }
    });
  }

  function refreshDrawer(){
    fetch('/?section_id=cart-drawer').then(function(res){ return res.text(); }).then(function(html){
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var newDrawer = doc.getElementById('CartDrawer');
      if(newDrawer && drawer){ drawer.innerHTML = newDrawer.innerHTML; }
      updateCartCount();
    });
  }

  var productForm = document.getElementById('ProductForm');
  if(productForm){
    productForm.addEventListener('submit', function(e){
      e.preventDefault();
      var formData = new FormData(productForm);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function(res){ return res.json(); })
        .then(function(){ refreshDrawer(); openDrawer(); })
        .catch(function(){ productForm.submit(); });
    });
  }

  document.addEventListener('click', function(e){
    var incr = e.target.closest('[data-qty-increase]');
    var decr = e.target.closest('[data-qty-decrease]');
    if(incr || decr){
      var trigger = incr || decr;
      var line = trigger.getAttribute('data-line');
      var span = trigger.parentElement.querySelector('span');
      var qty = parseInt(span.textContent, 10);
      qty = incr ? qty + 1 : Math.max(0, qty - 1);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function(){ refreshDrawer(); });
    }
  });

  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.getElementById('MobileNav');
  if(menuToggle && mobileNav){
    menuToggle.addEventListener('click', function(){ mobileNav.classList.toggle('is-open'); });
  }

  var track = document.getElementById('AnnouncementTrack');
  if(track){
    var slides = track.querySelectorAll('.gm-announcement__slide');
    if(slides.length > 1){
      var index = 0;
      var autoRotate = track.getAttribute('data-autorotate') === 'true';
      var speed = (parseInt(track.getAttribute('data-speed'), 10) || 5) * 1000;
      if(autoRotate){
        setInterval(function(){
          slides[index].style.display = 'none';
          index = (index + 1) % slides.length;
          slides[index].style.display = 'flex';
        }, speed);
      }
    }
  }

  var mainImage = document.getElementById('ProductMainImage');
  document.querySelectorAll('.gm-product__thumb').forEach(function(thumb){
    thumb.addEventListener('click', function(){
      var fullSrc = thumb.getAttribute('data-full-src');
      if(mainImage && fullSrc){
        mainImage.src = fullSrc;
        mainImage.srcset = '';
      }
      document.querySelectorAll('.gm-product__thumb').forEach(function(t){ t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
});